enum VehiclePermissions {
  CREATE_VEHICLE = 'CREATE_VEHICLE',
  UPDATE_VEHICLE = 'UPDATE_VEHICLE',
  DELETE_VEHICLE = 'DELETE_VEHICLE',
  READ_VEHICLE = 'READ_VEHICLE'
}

export default VehiclePermissions;